export const LIFERAY_WEB_CONSTANT = {
  disclosure: {
    type: 'json',
    id: 'MYACCOUNT-DISCLOSURE',
  },
  privacyPolicy: {
    type: 'text',
    id: 'NEW_MYACCOUNT_PRIVACY-POLICY',
  },
  termsOfUSe: {
    type: 'text',
    id: 'NEW-MYACCOUNT-TERMS-OF-USE',
  },
  message_by_content: {
    type: 'json',
    id: 'MY-ACCOUNT-MESSAGES-BY-SCENARIO',
  },
  operation_content: {
    type: 'json',
    id: 'MY-ACCOUNT-OPERATION-ITEMS-BY-FEATURE',
  },
  banner_content: {
    type: 'json',
    id: 'MYACCOUNT-BANNER-MESSAGES',
  },
  paymentTermsAndConditions: {
    type: 'json',
    id: '986030',
  },
  ncc_disclosure: {
    type: 'json',
    id: 'NCC-DISCLOSURE',
  },
  reimbursement_content: {
    type: 'html',
    id: 'reimbursement-instructions',
  },
  dashboard_content: {
    type: 'json',
    id: 'MYACCOUNT-DASHBOARD-RESOURCE',
  },
  error_content: {
    type: 'json',
    id: 'MYACCOUNT-HTTP-ERROR-CONTENT',
  },
  contact_us_content: {
    type: 'json',
    id: 'MYACCOUNT-CONTACTUS-MESSAGE',
  },
  social_links_content: {
    type: 'json',
    id: 'MYA_SOCIAL_LINKS',
  },
  cross_sell_clients: {
    type: 'json',
    id: 'MY-ACCOUNT-CROSS-SELL-ENROLLMENT-CLIENTS',
  },
  cross_sell_ce_content: {
    type: 'json',
    id: 'MY-ACCOUNT-CROSS-SELL-ENROLLMENT-CONTENT-CE',
  },
  cross_sell_surge_content: {
    type: 'json',
    id: 'MY-ACCOUNT-CROSS-SELL-ENROLLMENT-CONTENT-SURGE',
  },
  perks_benefits_content: {
    type: 'json',
    id: 'MY-ACCOUNT-PERKS-BENEFITS-RESOURCE',
  },
  feature_flags: {
    type: 'json',
    id: 'MY-ACCOUNT-FEATURE-FLAGS',
  },
  poc_how_to_take_picture: {
    type: 'json',
    id: 'AI-POC-HOW-TO-TAKE-GOOD-PICTURE',
  },
  confirmation_resources: {
    type: 'json',
    id: 'MY-ACCOUNT-CONFIRMATION-RESOURCES',
  },
  cross_sell_resources: {
    type: 'json',
    id: 'MY-ACCOUNT-CROSS-SELL-RESOURCES',
  }
};

export const LIFERAY_CMS_LABEL = 'liferayCMS';

export const LIFERAY_WHY_CREATE_ACCOUNT_WEB_CONSTANT = {
  createAccount: {
    type: 'html',
    id: 'WHY-CREATE-ONLINE-ACCOUNT',
  }
};

export const ERROR_PAGE_DEFAULT_CONTENT = [
  {
    'errorCode': '500',
    'errorHeader': 'We are temporarily down for scheduled maintenance.',
    'subheaderText': 'We will be back shortly. We apologize for any inconvenience.',
    'paragraphContent': '',
    'linkLabels': []
  },
  {
    'errorCode': '400',
    'errorHeader': 'Breakdowns happen.',
    'subheaderText': '',
    'paragraphContent': 'Sorry, we can\'t find the page you\'re looking for.<br>It could be because it moved or no longer exists.',
    'linkLabels': []
  }
];
